import React from 'react'
import { Modal } from 'react-bootstrap';
import DynamicForm from '../components/DynamicForm';
import { devicePolicyFormFields } from './DevicePolicyFieldsConfig';
import { toast } from 'react-toastify';

export const UpdateDevicePolicy = ({ show, onClose, onSubmit, defaultValues }) => {
  const formattedValues = {
    ...defaultValues,
    policyJson: defaultValues?.policyJson
      ? JSON.stringify(JSON.parse(defaultValues.policyJson), null, 2)
      : '',
  };
  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
        <Modal.Header closeButton>
            <Modal.Title>Edit Device Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <DynamicForm
                formClass={"policy-form"}
                fields={devicePolicyFormFields}
                onSubmit={onSubmit}
                onError={(err) => console.log("Validation Errors:", err)}
                onClose={onClose}
                defaultValues={formattedValues}
                disabledFields={["name"]}
            />
        </Modal.Body>
    </Modal>
  )
}